import { useMutation } from '@tanstack/react-query';

import type { MutationResponse } from '@/types';

import { HttpClient } from '@/network/HttpClient';

export const useSubscribeToCardMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<{ payment_url: string }>({ method: 'POST', url }),
  });

export const usePurchaseStartServiceMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<{ payment_url: string }>({ method: 'POST', url }),
  });

export const useCancelCardSubscriptionMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<MutationResponse>({ method: 'POST', url }),
  });
